import { render } from "./ProductVue.vue?vue&type=template&id=6f2b0be7&scoped=true"
import script from "./ProductVue.vue?vue&type=script&lang=js"
export * from "./ProductVue.vue?vue&type=script&lang=js"

import "./ProductVue.vue?vue&type=style&index=0&id=6f2b0be7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2b0be7"]])

export default __exports__